// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"981def70","151":"7d7864fc","269":"fcd84f25","453":"83d4beb0","591":"25cd251f","606":"e6327d29","777":"8ec6d7b6","834":"1f8b0734","982":"d63873dc"}[chunkId] + ".chunk.js";
};